
'use strict'

/**
 * Shared constants
 * These constants are intended to be shared between the server and client
 */

exports.LOCKOUT_REASON_MTUS = 'over_mtus'
exports.LOCKOUT_REASON_PAST_DUE = 'past_due'



// WEBPACK FOOTER //
// ../shared/constants.js